import React, { useMemo } from "react";
import {
  ObjectWeekDayTitles,
  ObjectRankingParameterTypeCssClasses
} from "../../ObjectsUIHelpers";
import { FormattedMessage } from "react-intl";


const getValue = (type) => {
  if (type) {
    if (type === "Sunday" || type === "1") return 1;
    if (type === "Monday" || type === "2") return 2;
    if (type === "Tuesday" || type === "3") return 3;
    if (type === "Wednesday" || type === "4") return 4;
    if (type === "Thursday" || type === "5") return 5;
    if (type === "Friday" || type === "6") return 6;
    if (type === "Saturday" || type === "7") return 7;
  } else return 0;
};


const setRow = (row) => {

  return (
    < span
      className={`label label-lg label-light-${ObjectRankingParameterTypeCssClasses[row.weekDay]} label-inline`
      }
    >
      {ObjectWeekDayTitles[row.weekDay]}
    </span >
  )
}

export const WeekDayColumnFormatter = (cellContent, row) => setRow(row);

export const indexN = (cellContent, row, index) => {
  return (<div>{index}</div>)
}